(() => {
  'use strict';

  if (window.PWProductConversionFlowLoaded) return;
  window.PWProductConversionFlowLoaded = true;

  const parseMoney = (value) => {
    const text = String(value || '').replace(/\u00a0/g, ' ').trim();
    if (!text || /gratis/i.test(text)) return 0;

    let number = text.replace(/[^0-9,.-]/g, '');
    if (!number) return 0;

    if (number.includes(',')) {
      number = number.replace(/\./g, '').replace(',', '.');
    }

    const parsed = Number.parseFloat(number);
    return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
  };

  const money = (cents) => {
    const amount = Number(cents || 0) / 100;
    if (Math.abs(amount - Math.round(amount)) < 0.00001) {
      return `€${Math.round(amount).toLocaleString('nl-NL')},-`;
    }
    return `€${amount.toLocaleString('nl-NL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const serviceUnitPrice = (input) => {
    const card = input.closest('.pw-service-card');
    const price = card && card.querySelector('.pw-service-price');
    if (price) return parseMoney(price.textContent);

    const group = input.closest('[data-pw-choice-group]');
    const choicePrice = group && group.querySelector('[data-pw-choice-price]');
    return choicePrice ? parseMoney(choicePrice.textContent) : 0;
  };

  const installationInput = (form) =>
    form.querySelector('.pw-service-input[data-pw-service-group="installation"]');

  const installationCopy = (form) => {
    const input = installationInput(form);
    if (!input) return 'Standaard installatie kost €15,- extra.';

    const cents = serviceUnitPrice(input);
    const title = String(input.dataset.pwServiceTitle || '').toLowerCase();
    const label = title.includes('vrijstaande vaatwasser')
      ? 'Plaatsing onder het aanrechtblad'
      : 'Inbouwservice';

    return cents > 0
      ? `Inbouwen is niet inbegrepen. ${label}: ${money(cents)}.`
      : 'Inbouwen is niet inbegrepen en heeft een apart tarief.';
  };

  const clarifyInstallationFlow = (form) => {
    const input = installationInput(form);
    if (!input) return;

    const choice = form.querySelector('.pw-product-service-choice');
    if (!choice) return;

    const header = choice.querySelector('.pw-product-service-choice__header');
    if (header) {
      const title = header.querySelector('strong');
      const text = header.querySelector('span');
      if (title) title.textContent = 'Bezorging en inbouw';
      if (text) text.textContent = 'Inbouwen is een aparte keuze met een eigen tarief.';
    }

    const standard = choice.querySelector('[data-pw-product-service-level][value="standard_installation"]');
    const standardCard = standard && standard.closest('.pw-product-service-level');
    const standardBody = standardCard && standardCard.querySelector('.pw-product-service-level__body');
    if (standardBody) {
      const title = standardBody.querySelector('strong');
      const description = standardBody.querySelector('span');
      if (title) title.textContent = 'Bezorging zonder inbouw';
      if (description) description.textContent = 'Bezorging €20,-. Inbouwen is niet inbegrepen.';
    }

    const details = choice.querySelector('details.pw-buybox-options');
    const summaryLabel = details && details.querySelector(':scope > summary > span');
    if (summaryLabel) summaryLabel.textContent = 'Inbouw en extra opties';

    const card = input.closest('.pw-service-card');
    const body = card && card.querySelector('.pw-service-card__body');
    const description = body && body.querySelector('span');
    if (description) {
      const title = String(input.dataset.pwServiceTitle || '').toLowerCase();
      description.textContent = title.includes('vrijstaande vaatwasser')
        ? 'Plaatsing van een vrijstaande vaatwasser onder een bestaand aanrechtblad. Controleer vooraf de maatvoering.'
        : 'Inbouw in een bestaande, passende nis. Controleer vooraf de maatvoering.';
    }
  };

  const quantityOf = (form) => {
    const input = form.querySelector('input[name="quantity"]');
    return Math.max(1, Number.parseInt(input && input.value || '1', 10) || 1);
  };

  const basePrice = (form) => {
    const buybox = form.closest('.pw-product-hero__buybox') || form.parentElement;
    const price = buybox && buybox.querySelector('[data-pw-price-current]');
    return price ? parseMoney(price.textContent) : 0;
  };

  const selectedServicesTotal = (form, quantity) => {
    let total = 0;

    form.querySelectorAll('.pw-service-input:checked').forEach((input) => {
      if (input.closest('[hidden]')) return;

      const unitPrice = serviceUnitPrice(input);
      const group = String(input.dataset.pwServiceGroup || '').toLowerCase();
      const title = String(input.dataset.pwServiceTitle || '').toLowerCase();

      if (group === 'delivery' && title.includes('boven') && quantity > 1) {
        total += unitPrice + Math.round(unitPrice / 2) * (quantity - 1);
      } else {
        total += unitPrice * quantity;
      }
    });

    return total;
  };

  const ensureTotal = (form) => {
    let total = form.querySelector('[data-pw-buybox-total]');
    if (total) return total;

    total = document.createElement('div');
    total.className = 'pw-buybox-total';
    total.dataset.pwBuyboxTotal = '';
    total.setAttribute('aria-live', 'polite');
    total.innerHTML = [
      '<span class="pw-buybox-total__label">',
      '<strong>Product + gekozen opties</strong>',
      '<small data-pw-buybox-service-note></small>',
      '</span>',
      '<strong class="pw-buybox-total__value" data-pw-buybox-total-value></strong>'
    ].join('');

    const quantityRow = form.querySelector('.pw-quantity-row');
    if (quantityRow) quantityRow.insertAdjacentElement('beforebegin', total);
    else form.appendChild(total);
    return total;
  };

  const updateTotal = (form) => {
    const quantity = quantityOf(form);
    const total = (basePrice(form) * quantity) + selectedServicesTotal(form, quantity);
    const totalBox = ensureTotal(form);
    const output = totalBox.querySelector('[data-pw-buybox-total-value]');
    const note = totalBox.querySelector('[data-pw-buybox-service-note]');

    if (output) output.textContent = money(total);
    if (note) {
      note.textContent = `Bezorging kost €20,- en wordt bij het afrekenen berekend; afhalen is ook mogelijk. ${installationCopy(form)}`;
    }
  };

  const makeOptionsPermanent = (form) => {
    form.querySelectorAll('details.pw-buybox-options').forEach((details) => {
      details.classList.add('pw-buybox-options--always-open');
      details.open = true;

      const summary = details.querySelector(':scope > summary');
      if (summary) {
        summary.tabIndex = -1;
        summary.setAttribute('aria-disabled', 'true');
      }

      if (details.dataset.pwAlwaysOpenBound !== 'true') {
        details.dataset.pwAlwaysOpenBound = 'true';
        details.addEventListener('toggle', () => {
          if (!details.open) details.open = true;
        });
      }
    });
  };

  const initForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return;
    makeOptionsPermanent(form);
    clarifyInstallationFlow(form);
    updateTotal(form);

    if (form.dataset.pwConversionFlowBound === 'true') return;
    form.dataset.pwConversionFlowBound = 'true';

    const scheduleUpdate = () => window.setTimeout(() => {
      makeOptionsPermanent(form);
      clarifyInstallationFlow(form);
      updateTotal(form);
    }, 0);

    form.addEventListener('change', scheduleUpdate, true);
    form.addEventListener('input', (event) => {
      if (event.target && event.target.matches('input[name="quantity"]')) scheduleUpdate();
    }, true);

    const buybox = form.closest('.pw-product-hero__buybox');
    const price = buybox && buybox.querySelector('[data-pw-price-current]');
    if (price) {
      new MutationObserver(scheduleUpdate).observe(price, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  };

  const init = (root = document) => {
    root.querySelectorAll('form.pw-product-form[action*="/cart/add"]').forEach(initForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  new MutationObserver((records) => {
    let needsInit = false;
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('form.pw-product-form') || node.querySelector('form.pw-product-form')) needsInit = true;
      });
    });
    if (needsInit) init(document);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
